module.exports = __webpack_public_path__ + "static/media/leni-vedio.7634df71.mp4";